<template>
  <div class="main">
    <div class="form">
      <div class="formTitle">
        <div style="height:100%;display:flex;align-items: flex-start;line-height: 36px;"
             class="formTitleSpan">审核层级：
        </div>
        <div style="display:flex;align-items:center;flex-wrap: wrap;width:calc(100% - 90px)">
          <span v-for="(item,index) in levelData" :key="index" class="formTitleItem"
                :class="{ 'active': activeLevel===index }"
                @click="levelClick(index)">{{ item.hierarchy_name }}</span>
          <el-button
            style="height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;"
            size="mini"
            type="info"
            icon="el-icon-plus"
            circle
            @click="addClick(0)"
          />
          <el-button
            v-if="levelData.length>1"
            style="height: 22px;width: 22px;display: flex;align-items: center;justify-content: center;padding: 0;"
            size="mini"
            type="info"
            icon="el-icon-minus"
            circle
            @click="levelMinus"
          />
        </div>
      </div>
      <div class="formTable" style="margin-top: 5px">
        <div style="width:100%;margin:0 0 20px">
          <div style="display: inline-block;" class="formTitleSpan">添加员工：</div>
          <span style="color:#3388ff;cursor:pointer;" @click="addEmployee">添加</span>
        </div>
        <div class="formTitleContainer" style="width:100%">
          <el-table
            v-loading="tableLoad"
            :data="TableData"
            style="width: 100%"
            border
            stripe
            :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'40px',}"
            :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'40px',}"
          >
            <el-table-column label="序号" align="center" width="50px" type="index"/>
            <el-table-column prop="deptName" label="部门" align="center"/>
            <el-table-column prop="empName" label="姓名" align="center"/>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <span
                  style="cursor: pointer;color: rgba(58, 98, 215, 1);text-decoration: underline;"
                  @click="deleteClick(scope.row)">移除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog title="添加员工" :visible.sync="dialogVisible" width="500px"
               :close-on-click-modal="false" :before-close="handleClose">
      <div>
        <span style="display: inline-block;" class="formTitleSpan">员工姓名：</span>
        <el-select v-model="selectedPerson" style="width:calc(100% - 70px)" size="mini" filterable
                   multiple placeholder="请选择人员姓名">
          <el-option v-for="item in totalPerson" :key="item.empId" :label="item.empNm"
                     :value="item.empId">
            <span style="float:left">{{ item.empNm }}</span>
            <span style="float:right;color:#8492a6;font-size:13px;padding-right:20px;">{{
                item.depNm
              }}</span>
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" :loading="addBtn" @click="addConfirm">确定</el-button>
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAuditHierarchy,
  selectListByHierarchy,
  addAuditHierarchy,
  deleteAuditHierarchy,
  addEmployee,
  getEmployee,
  deleteEmployee,
} from '@/service/audit';

export default {
  components: {},
  data() {
    return {
      levelData: [], // 审核层级数据
      activeLevel: 0, // 当前审核层级下标
      activeId: '', // 当前层级id
      tableLoad: false, // 表格加载状态
      TableData: [], // 表格数据
      selectedPerson: [], // 已选中员工
      totalPerson: [], // 所有员工
      dialogVisible: false, // 添加员工弹窗显隐控制
      type: 1, // 当前审核页面
      addBtn: false,
    };
  },
  watch: {
    // 监听层级改变
    async activeLevel(val) {
      if (val !== '') {
        this.activeId = this.levelData[val] ? this.levelData[val].id : '';
        this.tableLoad = true;
        this._selectListByHierarchy(this.activeId);
        this.tableLoad = false;
      }
    },
    // 监听路由改变
    $route(newVal, oldVal) {
      console.log(newVal);
      if (newVal.params.type != oldVal.params.type) {
        this.init();
        this.type = newVal.params.type ? newVal.params.type : 1;
      }
    },
    // 切换页面
    type(newVal, oldVal) {
      this._getAuditHierarchy(newVal);
    },
  },
  async mounted() {
    this.type = this.$route.params.type ? this.$route.params.type : 1;
    this._getAuditHierarchy(this.type);
  },
  methods: {
    init() {
      this.levelData = [], // 审核层级数据
        this.activeLevel = 0, // 当前审核层级下标
        this.activeId = '', // 当前层级id
        this.tableLoad = false, // 表格加载状态
        this.TableData = [], // 表格数据
        this.selectedPerson = [], // 已选中员工
        this.totalPerson = [], // 所有员工
        this.dialogVisible = false, // 添加员工弹窗显隐控制
        this.addBtn = false;
      this.$forceUpdate();
    },
    // 获取审核层级
    async _getAuditHierarchy(val) {
      if (val && val != '') {
        const res = await getAuditHierarchy({ auditType: val });
        if (res.status !== 0) return this.$message.error(res.message);
        this.levelData = res.data;
        this.activeId = this.levelData[this.activeLevel] ? this.levelData[this.activeLevel].id : '';
        this._selectListByHierarchy(this.activeId);
      }
    },
    // 获取表格数据
    async _selectListByHierarchy(id) {
      if (this.levelData.length <= 0) {
        return false;
      }
      const obj = {
        auditType: this.type,
        hierarchyId: id,
      };
      const res = await selectListByHierarchy(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableData = res.data;
    },
    // 获取部门及员工
    async _getEmployee() {
      const res = await getEmployee(this.activeId);
      if (res.status !== 0) return this.$message.error(res.message);
      this.totalPerson = res.data;
    },
    // 打开添加员工弹窗
    addEmployee() {
      this.selectedPerson = [];
      this._getEmployee();
      this.dialogVisible = true;
    },
    // 确认添加员工
    async addConfirm() {
      if (this.selectedPerson.length <= 0) {
        return this.$message.warning('请选择员工姓名!');
      }
      const obj = `?hierarchyId=${this.activeId}&userLis=${this.selectedPerson.join(',')}`;
      this.addBtn = true;
      const res = await addEmployee(obj);
      this.addBtn = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.dialogVisible = false;
      this._selectListByHierarchy(this.activeId);
    },
    // 取消添加员工
    handleClose() {
      this.dialogVisible = false;
      this.selectedPerson = [];
      this.totalPerson = [];
    },
    // 表格移除数据
    deleteClick(row) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteEmployee(row.id);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this._selectListByHierarchy(this.activeId);
        })
        .catch(() => false);
    },
    // 层级标签点击事件
    levelClick(index) {
      this.activeLevel = index;
    },
    // 添加审核层级
    async addClick(val) {
      const res = await addAuditHierarchy(this.type);
      if (res.status !== 0) return this.$message.error(res.message);
      this._getAuditHierarchy(this.type);
    },
    // 移除审核层级
    levelMinus() {
      let message = '';
      if (this.levelData.length > 0) {
        const len = this.levelData.length;
        message = this.levelData[len - 1].hierarchy_name;
      } else {
        this.$message.warning('审核层级为空!');
      }
      this.$confirm(`是否删除审核层级第${message}数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteAuditHierarchy(this.type);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this._getAuditHierarchy(this.type);
        })
        .catch(() => false);
    },
  },
};
</script>


<style lang="scss" scoped>
.main {
  width: 100%;
  display: flex;
  justify-content: center;

  .form {
    width: 550px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &Title {
      display: flex;
      margin-bottom: 15px;

      &Span {
        width: 70px;
        font-size: 14px;
        font-weight: 600;
        font-family: "Microsoft Yahei", serif;
        color: #606266;
      }

      .active {
        background-color: #3388FF;
      }

      &Item {
        padding: 0 10px;
        height: 26px;
        background-color: #A4ADB3;
        border-radius: 5px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        margin: 5px 10px 5px 0;

        &:hover {
          cursor: pointer;
        }
      }

      &Container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 80%;

        span {
          color: rgba(58, 98, 215, 1);
          text-decoration: underline;
          margin-bottom: 5px;
          cursor: pointer;
        }

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }
      }
    }
  }

  .selectContainer {
    width: 100%;
    height: 400px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &Transfer {
      margin-bottom: 20px;
    }

    &BtnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  ::v-deep {
    .el-dialog__body {
      padding: 30px 30px 20px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
  }
}
</style>
